import React from 'react'
import Box from '../../../core/components/box/Box'
import Heading from '../../../core/components/typography/heading/Heading'
import Text from '../../../core/components/typography/text/Text'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import {subjectToImage} from '../../../core/less/SubjectToImage'
import {PrimaryButton} from '../../../core/components/unilink/index'

export default class GrandmasterOnboardingCard extends React.PureComponent {

  render() {
    const {dismissOnboarding, topicName, subjectParent} = this.props

    return (
      <Box maxWidth='40rem' paddingTop={8} width='100%'>
        <Box
          shape='round'
          overflow='hidden'
          display='flex'
          direction='column'
          color='white'
          shadow>
          <Box
            display='flex'
            justifyContent='center'
            overflow='hidden'
            maxHeight='15.6rem'
            color={`${SubjectToCSSName[subjectParent]}-nav`}>
            <img
              style={{
                height: '17.125rem',
                width: 'auto',
                position: 'relative',
                bottom: '-2.5rem'
              }}
              src={subjectToImage[subjectParent]} />
          </Box>
          <Box
            display='flex'
            direction='column'
            alignItems='center'
            paddingX={4}
            smPaddingX={10}
            paddingY={10}>
            <Box marginBottom={8}>
              <Heading size='lg' fontWeight='medium' align='center' overflow='normal'>Start practicing {topicName}</Heading>
            </Box>
            <Box marginBottom={7}>
              <Text fontWeight='book' smSize='lg' size='sm' overflow='normal' align='center' leading='tall'>
                Are you ready for a challenge? Build up a <b>streak count</b> by answering problems accurately in a row. If you need guidance, you can <b>review topic</b> explanations for help!
              </Text>
            </Box>
            <PrimaryButton onClick={dismissOnboarding} subjectColorId={subjectParent}>Get Started</PrimaryButton>
          </Box>
        </Box>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/GrandmasterOnboardingCard.js